var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: _vm.value } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "300" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("generating-pdf")))]),
          _c(
            "w-card-content",
            { style: { padding: "50px" } },
            [_c("w-progress-circular", { attrs: { medium: "" } })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }